export default __webpack_public_path__ + "static/relief-bg-e2f0ff04ca5091d9a1bc35f899fe92e7.png";